import * as auth from 'modules/auth';
import { selectXsrfToken } from 'modules/auth/selectors';
import watchProgress from 'model/watchProgress';
import { fetchAll } from 'modules/data/countries/actions';
import { fetchIsOnBehalfOfEmail, fetchIsSuspended, fetchRenewalTotal } from '../accountId';
import { fetchDetails } from '../accounts';
import { fetchOrderableItemByAccountId } from '../product';

export default async (dispatch, getState) => {
  const xsrfToken = await watchProgress(selectXsrfToken);
  if (!xsrfToken) {
    auth.actions.goToLogin();
    return;
  }

  const state = getState();
  const { accountId } = state.location.payload;

  await dispatch(fetchAll());
  await dispatch(fetchDetails(accountId));
  await dispatch(fetchOrderableItemByAccountId(accountId));
  await dispatch(fetchIsSuspended(accountId));
  await dispatch(fetchIsOnBehalfOfEmail(accountId));
  await dispatch(fetchRenewalTotal(accountId, true, true, true, true));
};
